var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"benefits-nav"},[_c('ul',{staticClass:"benefits-nav__dots"},_vm._l((_vm.count),function(n){return _c('li',{key:n,staticClass:"benefits-nav__dot",class:{'benefits-nav__dot--active': n === _vm.activeIndex + 1}})}),0),_vm._v(" "),_c('span',{staticClass:"benefits-nav__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c47db96","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BenefitsNav.vue
// module id = null
// module chunks = 